import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import modules from './modules'
//引入插件
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters,
  modules,
  plugins: [
    createPersistedState({
      key: 'kubuqi-game',
      storage: window.sessionStorage,
      paths: ['device', 'user']
    })
  ]
})
